module.exports = __webpack_public_path__ + "assets/img/sfytj.83bd35c4.png";